module.exports = __webpack_public_path__ + "img/ss-empty-imgs.75b42ceb.png";